import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addDepot: translate({ id: 'setup.depots.createNew' }),
    entitiesCount: (selected: number, count: number): string =>
      translate({
        id:
          selected > 0
            ? 'setup.depots.list.footerCountWithSelection'
            : 'setup.depots.list.footerCount',
        values: { count, selected },
      }),
    selectBtn: (allSelected: boolean): string =>
      translate({ id: allSelected ? 'global.deselectAll' : 'global.selectAll' }),
    visibilityBtn: (someVisible?: boolean): string =>
      translate({
        id: someVisible ? 'global.hideAll' : 'global.showAll',
      }),
    noEntries: {
      title: translate({ id: 'depots.list.noEntries.title' }),
      description: translate({ id: 'depots.list.noEntries.description' }),
      action: translate({ id: 'depots.list.noEntries.action' }),
    },
    noResults: {
      title: translate({ id: 'depots.list.noResults.title' }),
      description: translate({ id: 'depots.list.noResults.description' }),
    },
  }))

  return api
}
